import * as React from 'react';

import { Container, Header, Title, Text, Button, Icon, Footer, Left, Body, Right, Spinner, FooterTab, Subtitle } from 'native-base';
import { StyleSheet, Platform, Linking, WebView, PermissionsAndroid } from 'react-native';
import { connect } from 'react-redux';
import * as FileSystem from 'expo-file-system';

import * as _ from 'lodash';
import Pdf from '../../components/pdf';
import sharer from '../../components/sharer';
import downloader from '../../components/downloader';
import * as Print from 'expo-print';

import { fetchList, loadPreviews, loadReport, loadFilters } from './actions';
import CalCalDataApi from '../../api/CalCalDataApi';
import GLOBALS from '../../components/globals';

import ProfitLoss from './profitLoss';
import TaxForecast from './taxForecast';
import ReportFilter from '../../components/reportFilter';
import HamburgerMenu from '../../components/hamburgerMenu';
import Takings from './takings';
import Expenses from './expenses';

class ReportContainer extends React.Component {
	constructor(props) {
		super(props);
		this.state = { currPath: null, uri: null, fetching: false, pdfContent: null, pdfRaw: null, pdfName: null, htmlContent: null, reportData: {}, error: false, downloadUrl: null };
	}

	componentDidMount() {
		//we may have come here directly...
		if (!this.props.filters) this.props.loadFilters();
		if (!this.props.reports) this.props.dispatch(loadPreviews());
	}

	componentWillReceiveProps() {
		this.state.pdfContent = false;
		this.state.htmlContent = null;
	}

	onFilterSelected(filter) {
		//filter may be taxyear or period

		//id, text, minDate, maxDate, taxyear? -> needs dispatching -> sets reportsReducer.taxyear, etc
		const { params } = this.props.route;
		const { report } = params;
		__DEV__ && console.log('filter selected', filter);
		this.props.dispatch({
			type: 'SET_TAXYEAR',
			filter
		});
		if (report == 'ProfitLoss' || report == 'TaxForecast') {
			this.loadReport(report, filter);
		}
	}

	async getPdf(path) {
		//gets a simple PDF report
		this.setState({ fetching: true });
		CalCalDataApi.dataLoad(path, this.props.jwt, res => {
			//console.log(res);
			if (res) {
				this.setState({
					pdfContent: 'data:application/pdf;base64,' + res.content,
					pdfRaw: res.content,
					htmlContent: res.html,
					pdfName: res.name || 'Report',
					fetching: false
				});
			}
		});
	}

	loadReport(report, filter) {
		const { minDate, maxDate } = filter;
		const dates = minDate && maxDate ? '/' + minDate + ':' + maxDate : '';
		//loads a more sophisticated report

		this.setState({ fetching: true });
		__DEV__ && console.log('loadReport', report);
		CalCalDataApi.dataLoad('reports/' + report + dates, this.props.jwt, res => {
			if (__DEV__) console.log(res);
			if (!res.error) {
				this.setState({ fetching: false, reportData: { ...this.state.reportData, [report]: res }, downloadUrl: `${report}${dates}/download` });
			} else {
				this.setState({ error: true });
			}
		});
	}

	/* -- moved to downloadER
	download(report) {
		const base64Data = this.state.pdfContent; //`data:application/pdf;base64,` + res.content;
		if (Platform.OS == 'web') {
			const downloadLink = document.createElement('a');

			downloadLink.href = base64Data;
			downloadLink.download = `Report ${report}.pdf`;
			downloadLink.click();
		} else
			Linking.canOpenURL(base64Data)
				.then(supported => {
					if (!supported) {
						__DEV__ && console.log("Can't handle url: " + base64Data);
					} else {
						return Linking.openURL(base64Data);
					}
				})
				.catch(err => console.error('An error occurred', err));
	}*/
	setPdfUrl(url) {
		//for the standalone reports to give us their correct PDF url, for downloads etc
		this.setState({ downloadUrl: url });
	}

	downloadThen(what, url) {
		CalCalDataApi.dataLoad('reports/' + url, this.props.jwt, res => {
			//console.log(res);
			if (res && !res.error) {
				what == 's' && sharer(res.content, res.name);
				what == 'p' && Print.printAsync({ uri: 'data:application/pdf;base64,' + res.content });
				what == 'd' && downloader(res.content, res.name);
			}
		});
	}

	renderContent(reportUrl, report, taxOnly) {
		if (reportUrl == 'ProfitLoss')
			return (
				<ProfitLoss
					reportData={this.state.reportData && this.state.reportData[reportUrl]}
					filter={this.props.selectedFilter}
					doRefresh={() => {
						this.loadReport(report, this.props.selectedFilter);
					}}
					refreshing={this.state.fetching}
					jwt={this.props.jwt}
				/>
			);
		if (reportUrl == 'TaxForecast')
			return (
				<TaxForecast
					reportData={this.state.reportData && this.state.reportData[reportUrl]}
					doRefresh={() => {
						this.loadReport(report, this.props.selectedFilter);
					}}
					refreshing={this.state.fetching}
					navigation={this.props.navigation}
					taxOnly={taxOnly}
				/>
			);
		if (reportUrl == 'Takings')
			return <Takings navigation={this.props.navigation} vatReg={this.props.vatReg} filter={this.props.selectedFilter} jwt={this.props.jwt} sendPdfUrl={u => this.setPdfUrl(u)} />;
		if (reportUrl == 'Expenses')
			return <Expenses navigation={this.props.navigation} vatReg={this.props.vatReg} filter={this.props.selectedFilter} jwt={this.props.jwt} sendPdfUrl={u => this.setPdfUrl(u)} />;
		//const path = FileSystem.documentDirectory + `${reportUrl}-report.pdf`;
		//console.log(GLOBALS.client_id);
		if (this.state.pdfContent) return <Pdf pdfContent={this.state.pdfContent} htmlContent={this.state.htmlContent} />;

		return <Spinner style={{ flex: 1 }} />;
	}

	render() {
		//you get this.props.navigation.navigate({ name: 'Report', params: { report: item.report, desc: item.desc, url: item.url, filter: item.filter } })
		const { params } = this.props.route;
		const { report } = params;
		const { filters, taxyear, yearTotals, years, userInfo, navigation } = this.props;
		const reportDets = _.find(this.props.reports, { report });
		if (!reportDets) return null;
		const { desc, url, filter, subHeader } = reportDets;
		var { selectedFilter } = this.props;
		const { reportData, downloadUrl } = this.state;
		__DEV__ && console.log('url', url, 'filters', filters, 'selectedFilter', selectedFilter, 'filter', filter);

		const getReportElsewhere = url == 'Takings' || url == 'Expenses' || url == 'ProfitLoss';

		if (!selectedFilter && filters) selectedFilter = filters[0];
		if (!selectedFilter) return <Text>Filters not loaded</Text>;
		if (url == 'ProfitLoss' || url == 'TaxForecast') {
			//if no data at all, load
			if (!reportData.hasOwnProperty(url) && !this.state.fetching) this.loadReport(report, selectedFilter);
		} else if (getReportElsewhere) {
			__DEV__ && console.log('not getting here');
		} else if (!this.state.pdfContent && !this.state.fetching) {
			//skip if we're about to change...
			if (filter == 'm' && !selectedFilter.showDateSels) {
				__DEV__ && console.log('waiting');
			} else {
				var uri = url;
				if (filter == 'y') {
					uri = `${url}/${taxyear}`;
				} else if (filter == 't') {
					uri = `${url}/${selectedFilter.minDate}:${selectedFilter.maxDate}`;
				} else if (filter == 'm') {
					uri = `${url}/${selectedFilter.minDate}:${selectedFilter.maxDate}/m`;
				}
				console.log(`getting report ${uri}`);
				this.getPdf('reports/' + uri);
			}
		}

		const doShare = () => (getReportElsewhere ? this.downloadThen('s', downloadUrl) : sharer(this.state.pdfRaw, this.state.pdfName));
		const doPrint = () => (getReportElsewhere ? this.downloadThen('p', downloadUrl) : Print.printAsync({ uri: this.state.pdfContent }));
		const doDownload = () => (getReportElsewhere ? this.downloadThen('d', downloadUrl) : downloader(this.state.pdfRaw, this.state.pdfName));

		const taxOnly = userInfo && userInfo.user && userInfo.user.taxOnly;

		return (
			<Container>
				<Header span style={{ height: 'auto', minHeight: 56 }}>
					<Left style={{ alignSelf: 'flex-start', paddingTop: 4 }}>
						{taxOnly ? (
							<HamburgerMenu />
						) : (
							<Button transparent onPress={() => navigation.goBack()}>
								<Icon active name="ios-arrow-back" />
							</Button>
						)}
					</Left>
					<Body style={{ alignSelf: 'flex-start', paddingTop: 6, paddingBottom: 0 }}>
						<Title>{desc}</Title>
						<Subtitle>{subHeader}</Subtitle>
					</Body>
					<Right>
						{!!filter && (
							<ReportFilter
								filters={filters}
								years={years}
								taxyear={taxyear}
								filterType={filter}
								selected={selectedFilter}
								onFilterSelected={filt => this.onFilterSelected(filt)}
								style={{ backgroundColor: '#438eb9' }}
							/>
						)}
					</Right>
				</Header>
				{!!this.state.error && <Text>Error loading report. please try a different period or refresh.</Text>}
				{!this.state.error && this.renderContent(url, report, taxOnly)}
				{(!!this.state.pdfContent || getReportElsewhere) && (
					<Footer style={styles.footer}>
						{Platform.OS != 'web' && (
							<>
								<Button style={styles.bottomButton} onPress={doShare}>
									<Icon name="share" style={styles.bottomIcon} />
								</Button>

								<Button style={styles.bottomButton} onPress={doPrint}>
									<Icon name="print" style={styles.bottomIcon} />
								</Button>
							</>
						)}

						<Button style={styles.bottomButton} onPress={doDownload}>
							<Icon name="download" style={styles.bottomIcon} />
						</Button>
					</Footer>
				)}
			</Container>
		);
	}
}

const styles = StyleSheet.create({
	footer: {
		backgroundColor: '#295670',
		height: 40,
		justifyContent: 'space-around'
	},
	bottomButton: {
		//alignSelf: 'center',
		backgroundColor: '#295670',
		//paddingVertical: 20,

		justifyContent: 'center'
	},
	bottomIcon: {
		color: '#8fbcd6'
	}
});

// https://calc.al/app/data/reports/print.php?t=assets&html&y=2017

function bindAction(dispatch) {
	return {
		loadReport: (r, f) => dispatch(loadReport(r, f)),
		loadFilters: () => dispatch(loadFilters()),
		dispatch
	};
}

const mapStateToProps = state => ({
	reports: state.reportsReducer.reports, //list,
	isLoading: state.reportsReducer.isLoading,
	user: state.loginReducer.user,
	vatReg: state.globalReducer.busDetails.vatRegistered,
	years: state.globalReducer.yrs,
	filters: state.reportsReducer.filters,
	taxyear: state.reportsReducer.taxyear,
	selectedFilter: state.reportsReducer.filter,
	reportData: state.reportsReducer.reportData,
	jwt: state.loginReducer.jwt && state.loginReducer.jwt.token,
	userInfo: state.loginReducer.userInfo
});
export default connect(mapStateToProps, bindAction)(ReportContainer);
